import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType, rootEffectsInit } from '@ngrx/effects';
import { ActionCreator, Creator } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map, take, tap } from 'rxjs/operators';
import { HostChannelService } from '../../shared/services/host-channel.service';
import * as fromAuthActions from '../auth/actions';
import * as fromDeviceActions from '../device/actions';
import * as fromConversationActions from '../conversation/actions';

@Injectable()
export class HostChannelEffects {
  readonly initHostChannel$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(rootEffectsInit),
        take(1),
        tap(() => this.hostChannelService.initialize()),
      ),
    { dispatch: false },
  );

  readonly authentication$ = createEffect(() =>
    this.actionFromHostMessage('authentication', fromAuthActions.authenticate),
  );

  readonly isMobile$ = createEffect(() =>
    this.actionFromHostMessage('breakpointChanged', fromDeviceActions.isMobileChanged),
  );

  readonly openNewMessage$ = createEffect(() =>
    this.actionFromHostMessage('openNewMessage', fromConversationActions.initiateConversation),
  );

  constructor(private readonly actions$: Actions, private readonly hostChannelService: HostChannelService) {}

  private actionFromHostMessage<T extends string, C extends Creator>(
    hostType: string,
    actionCreator: ActionCreator<T, C>,
  ): Observable<ReturnType<typeof actionCreator>> {
    return this.hostChannelService.messageReceived$.pipe(
      filter(
        (messageEvent: MessageEvent<{ type: T; data: ReturnType<typeof actionCreator> }>) =>
          messageEvent?.data?.type === hostType,
      ),
      map(messageEvent => actionCreator(messageEvent.data.data) as ReturnType<typeof actionCreator>),
    );
  }
}
